import { Controller } from "@hotwired/stimulus";

const EXCLUDED = new Set(["authenticity_token", "_method"]);

// Disables submit buttons until the user changes a form field.
// Usage: add data-controller="dirty-form" to a <form> element.
export default class extends Controller {
  static targets = ["submit"];
  static values = { preDirty: Boolean };

  connect() {
    this._baseline = this.preDirtyValue ? "\x00pre-dirty" : this._serialize();
    this._submitting = false;
    this._update();
    this._onInput = () => this._update();
    this._onSubmitStart = () => {
      this._submitting = true;
      this._update();
    };
    this._onSubmitEnd = () => {
      this._submitting = false;
      this._update();
    };
    this.element.addEventListener("input", this._onInput);
    this.element.addEventListener("change", this._onInput);
    this.element.addEventListener("turbo:submit-start", this._onSubmitStart);
    this.element.addEventListener("turbo:submit-end", this._onSubmitEnd);
  }

  disconnect() {
    this.element.removeEventListener("input", this._onInput);
    this.element.removeEventListener("change", this._onInput);
    this.element.removeEventListener("turbo:submit-start", this._onSubmitStart);
    this.element.removeEventListener("turbo:submit-end", this._onSubmitEnd);
  }

  markDirty() {
    this._baseline = "\x00marked-dirty";
    this._update();
  }

  _update() {
    const dirty = this._serialize() !== this._baseline;
    this.submitTargets.forEach((btn) => {
      btn.disabled = this._submitting || !dirty;
    });
  }

  _serialize() {
    const parts = [];
    for (const el of this.element.elements) {
      if (!el.name || EXCLUDED.has(el.name)) continue;
      if (el.disabled) continue;
      if ((el.type === "checkbox" || el.type === "radio") && !el.checked) continue;
      parts.push(`${encodeURIComponent(el.name)}=${encodeURIComponent(el.value)}`);
    }
    return parts.join("&");
  }
}
